<template>
  <div class="page" v-loading="loading">
    <img src="../../assets/images/acmedback.png" class="topimg" alt="" />
    <div class="totle">
      <!-- <el-upload
        :action="apiUrl + '/api/api/web/ImgFile/UploadFile'"
        :headers="headers"
        class="upload-demo"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :on-success="filesuccess"
      >
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload> -->
      <van-uploader v-model="fileList" :after-read="afterRead" multiple :max-count="1" class="uptotal">
      </van-uploader>
      <div class="submit" @click="submit">确认提交</div>
    </div>
  </div>
</template>
<!-- <script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.3.0.js"></script> -->
<script>
export default {
  name: "upload",
  data() {
    return {
      apiUrl: process.env.BASE_URL,
      fileList: [],
      headers: {
        token: "",
      },
      sourcefile: [],
      fileUrl: null,
      loading: false,
    };
  },
  created() {
    document.title = "加入ACMED";
    this.getToken();
  },
  methods: {
    // backtoapp(){
    //   wx.miniProgram.navigateBack({})
    // },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      let that = this
      that.loading = true;
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      this.$axios
        .post("/api/api/web/ImgFile/UploadImg", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.RetCode == 10000) {
            that.loading = false;
            that.fileUrl = res.Data.Url;
          }
        });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    filesuccess(res, file, fileList) {
      console.log(res.Data.Url);
      this.sourcefile.push({
        url: res.Data.Url,
      });
    },
    getToken() {
      let that = this;
      var token = JSON.parse(sessionStorage.getItem("userInfo")).Token;
      that.headers = {
        token: token,
      };
    },
    submit() {
      let that = this;
      // if (this.sourcefile.length == 0) {
      if (!that.fileUrl) {
        that.$message({
          message: "请选择文件！",
          type: "error",
        });
      } else {
        let param = {
          // FileUrl: this.sourcefile[0].url,
          FileUrl: that.fileUrl,
        };
        that.$axios
          .post("/api/api/web/Customer/ACMEDUploadInfo", param)
          .then((res) => {
            if (res.RetCode == "10000") {
              that.$message({
                message: "上传成功！",
                type: "success",
              });
              that.$router.push("/newok");
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgb(247, 249, 253);
  // padding: 0.5rem 5%;
  // box-sizing: border-box;
}

.upload-demo {
  margin-left: 10%;
}

.titinput {
  margin-bottom: 0.5rem;
}

.submit {
  width: 80%;
  margin: auto;
  height: 35px;
  line-height: 35px;
  border-radius: 35px;
  background: linear-gradient(to right, rgb(0, 72, 148), rgb(1, 153, 226));
  color: #ffffff;
  text-align: center;
  margin-top: 0.5rem;
}

.totle {
  position: absolute;
  width: 100%;
  top: 10%;
  transform: translateY(-50%);
}

.topimg {
  width: 100%;
}

.uptotal {
  display: block;
}

::v-deep .van-uploader__wrapper {
  justify-content: center;
}

::v-deep .van-uploader__upload {
  margin: 0;
  margin-top: 8rem;
  width: 5rem;
  height: 5rem;
  border: 1px solid rgb(182, 215, 234);
  border-radius: 20px;
}

::v-deep .van-uploader__preview {
  margin: 0;
  margin-top: 8rem;
  width: 5rem;
  height: 5rem;
  border: 1px solid rgb(182, 215, 234);
  border-radius: 20px;
}

::v-deep .van-uploader__preview-image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
</style>